import { Radio } from 'antd';
import styles from './index.module.css';

export interface Option<T> {
  value: T;
  label: string;
}

interface OptionProps<T> {
  option: Option<T>;
  isSelected: boolean;
  onClick: (value: T) => void;
  radioClassName?: string;
}

export interface RadioToggleProps<T> {
  options: Option<T>[];
  initialValue?: T;
  value: T;
  onChange: (value: T) => void;
  containerClassName?: string;
  radioClassName?: string;
}

const OptionComponent = <T extends string | number>({
  option,
  isSelected,
  onClick,
  radioClassName = '',
}: OptionProps<T>) => {
  return (
    <div
      className={`${styles.optionCard} ${
        isSelected ? styles.selected : styles.notSelected
      }`}
      onClick={() => onClick(option.value)}
    >
      <Radio checked={isSelected} className={radioClassName} />
      <span>{option.label}</span>
    </div>
  );
};

const RadioToggle = <T extends string | number>({
  options,
  initialValue,
  value,
  onChange,
  containerClassName = '',
  radioClassName = '',
}: RadioToggleProps<T>) => {
  const selectedValue = value ?? initialValue ?? options[0]?.value;

  return (
    <div className={`${styles.radioToggleContainer} ${containerClassName}`}>
      {options.map(option => (
        <OptionComponent
          key={option.value}
          option={option}
          isSelected={selectedValue === option.value}
          onClick={() => onChange(option.value)}
          radioClassName={radioClassName}
        />
      ))}
    </div>
  );
};

export default RadioToggle;
